import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable()
export class SchoolDataService {
	public constructor(
		private api: ApiService
	) {}

	// CRUD
	public list = () => this.api.sendApiRequest('get', 'school/datatables').toPromise();
	public create = (data: any) => this.api.sendApiRequest('post', 'school', data).toPromise();
	public view = (id: string|number) => this.api.sendApiRequest('get', `school/${id}`).toPromise();
	public edit = (id: string|number, data: any) => this.api.sendApiRequest('put', `school/${id}`, data).toPromise();
	
	public delete = (id: string|number) => this.api.sendApiRequest('delete', `school/${id}`).toPromise();
	public participationdelete = (id: string|number) => this.api.sendApiRequest('post', `school/${id}/participationdelete`).toPromise();
}


// WEBPACK FOOTER //
// ./src/services/data.schools.service.ts